import { PRODUCT_CODE } from "../constants/productCodes";
import { tabTypes } from "../constants/tab-types";

const DRUG_MONOGRAPH_PUBTYPE = "drug-monograph";

export const findOnPageModes = Object.freeze({
  findInSection: "findInSection",
  findInTopic: "findInTopic",
  findInQuickAnswers: "findInQuickAnswers",
});

export const getFindOnPageMode = (tab, productCode, slugPubType) => {
  if (
    slugPubType === DRUG_MONOGRAPH_PUBTYPE &&
    productCode === PRODUCT_CODE.DMX
  ) {
    return tab === tabTypes.DETAILS
      ? findOnPageModes.findInSection
      : findOnPageModes.findInQuickAnswers;
  }

  return findOnPageModes.findInTopic;
};
